import React, {useCallback, useMemo, useState} from 'react';

import {useDialogController} from '_/hooks';

import {useFavorites} from '../hooks/useFavorites';
import {
  DraggableWorkLogSuggestion,
  EventApiWithWorkLogProps,
  EventTimers,
} from '../types';

import {RecentSearch} from './RecentSearch';
import {CreateFavoriteDialog} from './favorites/CreateFavoriteDialog';
import {Favorites} from './favorites/Favorites';

export const FavoritesAndRecent = ({
  timer,
  events,
}: {
  timer: EventTimers;
  events: EventApiWithWorkLogProps[];
}): React.ReactElement => {
  const {favorites, onFavoriteUpdated, onFavoriteDeleted} = useFavorites();
  const {isVisible, showDialog, closeDialog} = useDialogController();

  const [editingFavorite, setEditingFavorite] = useState<
    DraggableWorkLogSuggestion | undefined
  >(undefined);

  const handleEditDialog = useCallback(
    (item?: DraggableWorkLogSuggestion) => {
      setEditingFavorite(item);
      showDialog();
    },
    [showDialog]
  );

  const handleCloseDialog = () => {
    setEditingFavorite(undefined);
    closeDialog();
  };

  const dialog =
    editingFavorite || isVisible ? (
      <CreateFavoriteDialog
        data={editingFavorite}
        isOpen={true}
        onClose={handleCloseDialog}
        onEdit={onFavoriteUpdated}
      />
    ) : null;

  const memoizedFavorites = useMemo(
    () => (
      <Favorites
        favorites={favorites}
        setEditingFavorite={handleEditDialog}
        showDialog={showDialog}
        timer={timer}
        onFavoriteDeleted={onFavoriteDeleted}
      />
    ),
    [favorites, handleEditDialog, onFavoriteDeleted, showDialog, timer]
  );
  return (
    <>
      {dialog}
      {memoizedFavorites}
      <RecentSearch
        events={events}
        handleMakeFavorite={handleEditDialog}
        timer={timer}
      />
    </>
  );
};
